<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("concessiondailyReport") }}</div>
      <div class="mt-3 mb-0">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getConcessionDailyReportsSelectedCinema ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >

              <b-dropdown
                :text="getConcessionDailyReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onConcessionDailyReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getConcessionDailyReportFromDate"
                  v-on:click="
                    onConcessionDailyReportDateHandler({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onConcessionDailyReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  ref="programaticOpen"
                  typeable
                  :value="getConcessionDailyReportFromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getConcessionDailyReportFromDate ? 'active' : ''"
                  >{{ $t("From Date") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getConcessionDailyReportFromDate"
                  v-on:click="
                    onConcessionDailyReportDateHandler({
                      event: null,
                      name: 'toDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onConcessionDailyReportDateHandler({
                      event: $event,
                      name: 'toDate',
                    })
                  "
                  ref="programaticOpen"
                  typeable
                  :value="getConcessionDailyReportToDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getConcessionDailyReportToDate ? 'active' : ''"
                  >{{ $t("To Date") }}</label
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getConcessionReportSelectedPosUser &&
                  getConcessionReportSelectedPosUser.length > 0
                    ? 'shift-up'
                    : 'd-none'
                "
                >{{ $tc("user", 1) }}</label
              >
              <!-- <b-dropdown
                :text="getConcessionReportSelectedPosUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getPosUsersList"
                  :key="dropdownIndex"
                  @click="onDailyReportDropdownHandler({ event: $event, name:'PosUser',selectedItem: dropdownItem, index:dropdownIndex })"
                >
                  <span>{{ dropdownItem.user_id ? `${dropdownItem.first_name} ${dropdownItem.middle_name } ${ dropdownItem.last_name }`: 'All' }}</span>
                </b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="getPosUsersList"
                :searchable="true"
                :placeholder="
                  getConcessionReportSelectedPosUser &&
                  getConcessionReportSelectedPosUser.length > 0
                    ? getConcessionReportSelectedPosUser
                    : 'User'
                "
                :customLabel="setLabel"
                track-by="user_id"
                @select="
                  onConcessionDailyReportDropDownHandler({
                    event: $event,
                    name: 'PosUser',
                    selectedItem: $event,
                  })
                "
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <button
              @click="onFetchDailyConcessionReport"
              class="btn-blue-lg w-100"
            >
              {{ $tc("getReport") }}
            </button>
          </div>

          <div
            v-if="getConcessionDailyReportData.length > 0"
            class="w-100 d-flex w-100 justify-content-end my-2"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getConcessionDailyPdfFileName"
              :href="BASE_URL + getConcessionDailyPdfFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getConcessionDailyExcelFileName"
              :href="BASE_URL + getConcessionDailyExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <!-- new table -->
      <div
        class="table-scroll"
        v-if="getConcessionDailyReportData.length > 0 && false"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey">
            <!-- <tr> -->
            <th>{{ $tc("outlet") }}</th>
            <th>{{ $tc("username") }}</th>
            <th>{{ $tc("Sale Date") }}</th>
            <th>{{ $tc("item") }}</th>
            <th>Category</th>
            <th>{{ $tc("payment") }}</th>
            <th>{{ $tc("offer") }}</th>
            <th>{{ $tc("quantity") }}</th>
            <th>{{ $tc("gross") }} {{ $tc("revenue") }}</th>
            <th>{{ $tc("net") }} {{ $tc("revenue") }}</th>
            <th>{{ $tc("discount") }}</th>
            <th>{{ $tc("balance") }}</th>
            <!-- </tr> -->
          </thead>
          <tbody
            v-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length == 0
            "
          >
            <tr rowspan="9">
              <td colspan="11">
                <!-- {{ $tc("NoRecords") }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length > 0
            "
          >
            <template
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
            >
              <tr :key="ConcessionIndex">
                <td
                  :rowspan="ConcessionItem.newFnbItems.length + 1"
                  class="text-left"
                >
                  {{
                    ConcessionItem.FnbItems[0].paymentTypes[0]
                      .fst_booking_source
                  }}
                </td>
                <td
                  :rowspan="ConcessionItem.newFnbItems.length + 1"
                  class="text-left"
                >
                  {{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}
                </td>
              </tr>
              <template
                v-for="(
                  PaymentItem, paymentIndex
                ) in ConcessionItem.newFnbItems"
              >
                <tr :key="paymentIndex">
                  <td>{{ PaymentItem.sales_date }}</td>
                  <!-- fst_created_at -->
                  <td class="text-left">
                    {{ PaymentItem.fst_item_name }}
                  </td>
                  <td class="text-left">{{ PaymentItem.fc_category || "" }}</td>
                  <td class="text-left">{{ PaymentItem.fst_payment_mode }}</td>
                  <td class="text-left">
                    {{ PaymentItem.ft_offer_name || "-" }}
                  </td>
                  <td class="text-right">{{ PaymentItem.total_quantity }}</td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem.total_amount) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem.net_amount) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem["ft_offer_price"]) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem["balance_amount"]) }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
          <tbody v-if="getConcessionDailyReportData.length > 0">
            <tr>
              <td class="bg-lightgrey">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <!-- <td class="bg-lightgrey">
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td> -->
              <td class="bg-lightgrey text-right font-weight-bold">
                {{ getGrandTotal.totalQuantity }}
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong v-if="getGrandTotal.totalRevenue">{{
                  currFormat(getGrandTotal.totalRevenue)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong v-if="getGrandTotal.totalNetAmount">{{
                  currFormat(getGrandTotal.totalNetAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong getGrandTotal.totalDiscount>{{
                  currFormat(getGrandTotal.totalDiscount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong getGrandTotal.totalBalance>{{
                  currFormat(getGrandTotal.totalBalance)
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report" v-if="getConcessionDailyReportData.length > 0">
        <table
          border="1"
          class="swc-report swc-report-table dailysales_report"
          style="table-layout: 'auto'"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th class="text-left">{{ "Channel" }}</th>
              <th class="text-left">User</th>
              <th class="p-0">
                <table class="fixed-layout-table table-elements-border">
                  <thead>
                    <tr>
                      <th class="text-left" style="width: auto">Item</th>
                      <th class="text-left">PayType</th>
                      <th class="text-left">Voucher</th>
                      <th class="text-left">Qty</th>
                      <th class="text-left">Cash</th>
                      <th
                        class="text-left"
                        style="white-space: break-spaces !important"
                      >
                        Credit Card
                      </th>
                      <th
                        class="text-left"
                        style="white-space: break-spaces !important"
                      >
                        Voucher Amt
                      </th>
                      <th
                        class="text-left"
                        style="white-space: break-spaces !important"
                      >
                        Cash Card
                      </th>
                      <!-- <th>Quantity</th> -->
                      <th
                        class="text-left"
                        style="white-space: break-spaces !important"
                      >
                        Total Sale
                      </th>
                      <th class="text-center">
                        <span class="fs-12">{{ "Balance" }}</span> <br />
                        <!-- <span class="fs-10 text-truncate">{{
                          "(Less discount)"
                        }}</span> -->
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody
            v-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length == 0
            "
          >
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length > 0
            "
            class="sph-report"
          >
            <template
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
            >
              <tr :key="ConcessionIndex">
                <td class="text-left font-weight-bold">
                  {{
                    ConcessionItem.FnbItems[0].paymentTypes[0]
                      .fst_booking_source
                  }}
                </td>
                <td class="text-left font-weight-bold">
                  {{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}
                </td>
                <td colspan="10" class="child-tables dailysales_report">
                  <table
                    v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                    :key="FnbItemIndex"
                    class="fixed-layout-table border"
                    border="1"
                  >
                    <tbody>
                      <tr
                        v-for="(
                          PaymentItem, PaymentIndex
                        ) in FnbItem.paymentTypes"
                        :key="PaymentIndex"
                      >
                        <td
                          class="text-left font-weight-bold word_break"
                          style="white-space: pre-line; width: auto"
                        >
                          {{
                            PaymentIndex == 0 ? PaymentItem.fst_item_name : ""
                          }}
                        </td>
                        <td class="text-left">
                          {{ PaymentItem.fst_payment_mode }}
                        </td>
                        <td
                          class="text-left word_break"
                          style="white-space: pre-line; width: auto"
                        >
                          {{
                            PaymentItem.ft_voucher_name ||
                            PaymentItem.ft_offer_name ||
                            "-"
                          }}
                        </td>
                        <td class="text-right">
                          {{ PaymentItem.total_quantity }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem.cash_amount) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem.payment_mode_amount) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem["ft_offer_price"]) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem.cash_card_amount) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem.total_amount) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(PaymentItem["balance_amount"]) }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          FnbItem.hasOwnProperty('DataRefund') &&
                          FnbItem.DataRefund.length > 0 &&
                          false
                        "
                        style="background-color: rgba(246, 194, 188, 0.5)"
                      >
                        <td class="text-left" colspan="10">Refund</td>
                      </tr>
                      <tr
                        v-if="
                          FnbItem.hasOwnProperty('DataRefund') &&
                          FnbItem.DataRefund.length > 0 &&
                          false
                        "
                        v-for="(
                          PaymentItem, PaymentIndex
                        ) in FnbItem.DataRefund"
                        :key="PaymentIndex"
                      >
                        <td class="text-left"></td>
                        <td class="text-left">
                          {{ PaymentItem.payment_mode }}
                        </td>
                        <td class="text-left">{{ "-" }}</td>
                        <td class="text-right">
                          {{
                            PaymentItem.items > 0 ? "-" + PaymentItem.items : 0
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              getNegativeValue(PaymentItem.cash_amount_refund)
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              getNegativeValue(
                                PaymentItem.payment_mode_amount_refund
                              )
                            )
                          }}
                        </td>
                        <td class="text-right">{{ currFormat(0) }}</td>
                        <td class="text-right">
                          {{
                            currFormat(
                              getNegativeValue(PaymentItem.cash_card_refund)
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              getNegativeValue(PaymentItem.total_refund)
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              getNegativeValue(PaymentItem["total_refund"])
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          FnbItem.hasOwnProperty('DataRefund') &&
                          FnbItem.DataRefund.length > 0 &&
                          false
                        "
                        style="background-color: rgba(211, 211, 211, 0.4)"
                      >
                        <td class="text-left">
                          <strong
                            >{{ $tc("refund", 1) }} {{ $t("total") }}</strong
                          >
                        </td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                          <strong>{{
                            FnbItem.DataRefund.reduce(function (
                              accumulator,
                              { items }
                            ) {
                              return accumulator + parseFloat(items);
                            },
                            0) > 0
                              ? "-" +
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { items }
                                ) {
                                  return accumulator + parseFloat(items);
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { items }
                                ) {
                                  return accumulator + parseFloat(items);
                                },
                                0)
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              getNegativeValue(
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { cash_amount_refund }
                                ) {
                                  return (
                                    accumulator + parseFloat(cash_amount_refund)
                                  );
                                },
                                0) > 0
                                  ? FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_amount_refund)
                                      );
                                    },
                                    0)
                                  : FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_amount_refund)
                                      );
                                    },
                                    0)
                              )
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              getNegativeValue(
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { payment_mode_amount_refund }
                                ) {
                                  return (
                                    accumulator +
                                    parseFloat(payment_mode_amount_refund)
                                  );
                                },
                                0) > 0
                                  ? FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { payment_mode_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(payment_mode_amount_refund)
                                      );
                                    },
                                    0)
                                  : FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { payment_mode_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(payment_mode_amount_refund)
                                      );
                                    },
                                    0)
                              )
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{ currFormat(0) }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              getNegativeValue(
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { cash_card_refund }
                                ) {
                                  return (
                                    accumulator + parseFloat(cash_card_refund)
                                  );
                                },
                                0) > 0
                                  ? FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_card_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_card_refund)
                                      );
                                    },
                                    0)
                                  : FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_card_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_card_refund)
                                      );
                                    },
                                    0)
                              )
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              getNegativeValue(
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { total_refund }
                                ) {
                                  return accumulator + parseFloat(total_refund);
                                },
                                0) > 0
                                  ? FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                                  : FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                              )
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              getNegativeValue(
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { total_refund }
                                ) {
                                  return accumulator + parseFloat(total_refund);
                                },
                                0) > 0
                                  ? FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                                  : FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                              )
                            )
                          }}</strong>
                        </td>
                      </tr>
                      <tr
                        style="background-color: rgba(169, 217, 251, 0.5)"
                        v-if="false"
                      >
                        <td class="text-left">
                          <strong>{{ $t("total") }}</strong>
                        </td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                          <strong>{{
                            FnbItem.DataRefund
                              ? FnbItem.paymentTypes.reduce(function (
                                  accumulator,
                                  { total_quantity }
                                ) {
                                  return (
                                    accumulator + parseFloat(total_quantity)
                                  );
                                },
                                0) -
                                FnbItem.DataRefund.reduce(function (
                                  accumulator,
                                  { items }
                                ) {
                                  return accumulator + parseFloat(items);
                                },
                                0)
                              : FnbItem.paymentTypes.reduce(function (
                                  accumulator,
                                  { total_quantity }
                                ) {
                                  return (
                                    accumulator + parseFloat(total_quantity)
                                  );
                                },
                                0)
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { cash_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(cash_amount)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_amount_refund)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { cash_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(cash_amount)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { payment_mode_amount }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(payment_mode_amount)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { payment_mode_amount_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(payment_mode_amount_refund)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { payment_mode_amount }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(payment_mode_amount)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { ft_offer_price }
                                  ) {
                                    return (
                                      accumulator + parseFloat(ft_offer_price)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { ft_offer_price }
                                    ) {
                                      return (
                                        accumulator + parseFloat(ft_offer_price)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { ft_offer_price }
                                  ) {
                                    return (
                                      accumulator + parseFloat(ft_offer_price)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { cash_card_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(cash_card_amount)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { cash_card_refund }
                                    ) {
                                      return (
                                        accumulator +
                                        parseFloat(cash_card_refund)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { cash_card_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(cash_card_amount)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { total_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(total_amount)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { total_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(total_amount)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{
                            currFormat(
                              FnbItem.DataRefund
                                ? FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { balance_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(balance_amount)
                                    );
                                  },
                                  0) -
                                    FnbItem.DataRefund.reduce(function (
                                      accumulator,
                                      { total_refund }
                                    ) {
                                      return (
                                        accumulator + parseFloat(total_refund)
                                      );
                                    },
                                    0)
                                : FnbItem.paymentTypes.reduce(function (
                                    accumulator,
                                    { balance_amount }
                                  ) {
                                    return (
                                      accumulator + parseFloat(balance_amount)
                                    );
                                  },
                                  0)
                            )
                          }}</strong>
                        </td>
                      </tr>
                      <tr
                        style="background-color: rgba(169, 217, 251, 0.5)"
                      ></tr>
                    </tbody>
                  </table>
                  <table
                    v-if="
                      ConcessionItem.FnbItems.some(
                        (FnbItem) =>
                          FnbItem.hasOwnProperty('DataRefund') &&
                          FnbItem.DataRefund.length > 0
                      )
                    "
                    class="fixed-layout-table border"
                    border="1"
                  >
                    <tr style="background-color: rgba(246, 194, 188, 0.5)">
                      <td class="text-left" colspan="10">Refund</td>
                    </tr>
                    <template
                      v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                    >
                      <tbody
                        :key="FnbItemIndex"
                        v-if="
                          FnbItem.hasOwnProperty('DataRefund') &&
                          FnbItem.DataRefund.length > 0
                        "
                      >
                        <tr
                          v-for="(
                            PaymentItem, PaymentIndex
                          ) in FnbItem.DataRefund"
                          :key="PaymentIndex"
                        >
                          <td
                            class="text-left font-weight-bold word_break"
                            style="
                              white-space: pre-line;
                              width: auto;
                              word-break: break-all;
                            "
                          >
                            {{
                              PaymentIndex == 0 ? PaymentItem.fst_item_name : ""
                            }}
                          </td>
                          <td class="text-left">
                            {{ PaymentItem.payment_mode || "-" }}
                          </td>
                          <td class="text-left">
                            {{ "-" }}
                          </td>
                          <td class="text-right">
                            {{ -PaymentItem.items }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(
                                getNegativeValue(PaymentItem.cash_amount_refund)
                              )
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(
                                getNegativeValue(
                                  PaymentItem.payment_mode_amount_refund
                                )
                              )
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(getNegativeValue(PaymentItem.discount))
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(
                                getNegativeValue(PaymentItem.cash_card_refund)
                              )
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(
                                getNegativeValue(PaymentItem.total_refund)
                              )
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(
                                getNegativeValue(PaymentItem["total_refund"])
                              )
                            }}
                          </td>
                        </tr>
                        <tr
                          style="background-color: rgba(169, 217, 251, 0.5)"
                        ></tr>
                      </tbody>
                    </template>
                  </table>
                </td>
              </tr>
              <tr :key="ConcessionIndex">
                <td class="bg-lightgrey text-left" colspan="2">
                  <strong>{{ $t("total") }}</strong>
                </td>
                <!-- <td class="bg-lightgrey">
                <strong></strong>
              </td> -->
                <td class="p-0">
                  <table
                    class="fixed-layout-table table-elements-border border"
                    border="1"
                  >
                    <thead>
                      <tr>
                        <td class="bg-lightgrey">
                          <strong></strong>
                        </td>
                        <td class="bg-lightgrey">
                          <strong></strong>
                        </td>
                        <td class="bg-lightgrey">
                          <strong></strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { total_quantity }) =>
                                    acc + total_quantity,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund("items", ConcessionItem.user_id)
                            )
                          }}</strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { cash_amount }) => acc + cash_amount,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "cash_amount_refund",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { payment_mode_amount }) =>
                                    acc + payment_mode_amount,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "payment_mode_amount_refund",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { ft_offer_price }) =>
                                    acc + ft_offer_price,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "ft_offer_price",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { cash_card_amount }) =>
                                    acc + cash_card_amount,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "cash_card_refund",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { total_amount }) => acc + total_amount,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "total_refund",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                        <!-- <td class="bg-lightgrey text-right">
                        <strong v-if="getGrandTotal.totalNetAmount">{{
                          currFormat(getGrandTotal.totalNetAmount)
                        }}</strong>
                      </td> -->
                        <td class="bg-lightgrey text-right">
                          <strong>{{
                            currFormat(
                              ConcessionItem.FnbItems.map((a) =>
                                a.paymentTypes.reduce(
                                  (acc, { balance_amount }) =>
                                    acc + balance_amount,
                                  0
                                )
                              ).reduce((a, b) => a + b, 0) -
                                subtractRefund(
                                  "total_refund",
                                  ConcessionItem.user_id
                                )
                            )
                          }}</strong>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-if="getConcessionDailyReportData.length > 0">
            <tr>
              <td class="bg-lightgrey text-left" colspan="2">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <!-- <td class="bg-lightgrey">
                <strong></strong>
              </td> -->
              <td class="p-0">
                <table
                  class="fixed-layout-table table-elements-border border"
                  border="1"
                >
                  <thead>
                    <tr>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <!-- <td class="bg-lightgrey"> <td class="bg-lightgrey">
                        <strong v-if="getGrandTotal.totalRevenue">{{
                          currFormat(getGrandTotal.totalRevenue)
                        }}</strong>
                      </td>
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td> -->
                      <td class="bg-lightgrey text-right">
                        <strong>{{ getGrandTotal.totalQuantity }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong>{{
                          currFormat(getGrandTotal.totalCashAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong>{{
                          currFormat(getGrandTotal.totalPaymentModeAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong getGrandTotal.totalDiscount>{{
                          currFormat(getGrandTotal.totalDiscount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong>{{
                          currFormat(getGrandTotal.totalCashCardAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong v-if="getGrandTotal.totalRevenue">{{
                          currFormat(getGrandTotal.totalRevenue)
                        }}</strong>
                      </td>
                      <!-- <td class="bg-lightgrey text-right">
                        <strong v-if="getGrandTotal.totalNetAmount">{{
                          currFormat(getGrandTotal.totalNetAmount)
                        }}</strong>
                      </td> -->
                      <td class="bg-lightgrey text-right">
                        <strong getGrandTotal.totalBalance>{{
                          currFormat(getGrandTotal.totalBalance)
                        }}</strong>
                      </td>
                    </tr>
                  </thead>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- new table -->

      <div class="swc-report" v-if="false">
        <table
          border="1"
          class="swc-report swc-report-table td-ellipsis"
          style="table-layout: fixed !important"
        >
          <thead class="bg-lightgrey">
            <!-- <tr> -->
            <th>{{ $tc("outlet") }}</th>
            <th>{{ $tc("username") }}</th>
            <th>{{ $tc("Sale Date") }}</th>
            <th>{{ $tc("item") }}</th>
            <th>Category</th>
            <th>{{ $tc("payment") }}</th>
            <th>{{ $tc("offer") }}</th>
            <th>{{ $tc("quantity") }}</th>
            <th>{{ $tc("gross") }} {{ $tc("revenue") }}</th>
            <th>{{ $tc("net") }} {{ $tc("revenue") }}</th>
            <th>{{ $tc("discount") }}</th>
            <th>{{ $tc("balance") }}</th>
            <!-- </tr> -->
          </thead>
          <tbody
            v-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length == 0
            "
          >
            <tr rowspan="9">
              <td colspan="11">
                <!-- {{ $tc("NoRecords") }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length > 0
            "
            class="sph-report"
          >
            <tr
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
              :key="ConcessionIndex"
            >
              <td>
                {{
                  ConcessionItem.FnbItems[0].paymentTypes[0].fst_booking_source
                }}
              </td>
              <td>{{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}</td>
              <td colspan="10" class="child-tables">
                <table
                  v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                  :key="FnbItemIndex"
                >
                  <tr
                    v-for="(PaymentItem, PaymentIndex) in FnbItem.paymentTypes"
                    :key="PaymentIndex"
                  >
                    <td>{{ PaymentItem.sales_date }}</td>
                    <!-- fst_created_at -->
                    <td>
                      {{ PaymentIndex == 0 ? PaymentItem.fst_item_name : "" }}
                    </td>
                    <td class="text-left">
                      {{ PaymentItem.fc_category || "" }}
                    </td>
                    <td class="text-left">
                      {{ PaymentItem.fst_payment_mode }}
                    </td>
                    <td class="text-left">
                      {{ PaymentItem.ft_offer_name || "-" }}
                    </td>
                    <td class="text-right">{{ PaymentItem.total_quantity }}</td>
                    <td class="text-right">
                      {{ currFormat(PaymentItem.total_amount) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(PaymentItem.net_amount) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(PaymentItem["ft_offer_price"]) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(PaymentItem["balance_amount"]) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <template
              v-if="false"
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
            >
              <tr :key="ConcessionIndex">
                <td :rowspan="ConcessionItem.FnbItems.length + 1">
                  {{
                    ConcessionItem.FnbItems[0].paymentTypes[0]
                      .fst_booking_source
                  }}
                </td>
                <td :rowspan="ConcessionItem.FnbItems.length + 1">
                  {{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}
                </td>
              </tr>
              <template
                v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
              >
                <tr
                  v-for="(PaymentItem, PaymentIndex) in FnbItem.paymentTypes"
                  :key="PaymentIndex + 'PaymentTypes' + FnbItemIndex"
                >
                  <td>{{ PaymentItem.sales_date }}</td>
                  <!-- fst_created_at -->
                  <td>
                    {{ PaymentIndex == 0 ? PaymentItem.fst_item_name : "" }}
                  </td>
                  <td class="text-left">{{ PaymentItem.fc_category || "" }}</td>
                  <td class="text-left">{{ PaymentItem.fst_payment_mode }}</td>
                  <td class="text-left">
                    {{ PaymentItem.ft_offer_name || "-" }}
                  </td>
                  <td class="text-right">{{ PaymentItem.total_quantity }}</td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem.total_amount) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem.net_amount) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem["ft_offer_price"]) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(PaymentItem["balance_amount"]) }}
                  </td>
                </tr></template
              >
            </template>
          </tbody>
          <tbody v-if="getConcessionDailyReportData.length > 0">
            <tr>
              <td class="bg-lightgrey">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <!-- <td class="bg-lightgrey">
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td> -->
              <td class="bg-lightgrey text-right font-weight-bold">
                {{ getGrandTotal.totalQuantity }}
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong v-if="getGrandTotal.totalRevenue">{{
                  currFormat(getGrandTotal.totalRevenue)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong v-if="getGrandTotal.totalNetAmount">{{
                  currFormat(getGrandTotal.totalNetAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong getGrandTotal.totalDiscount>{{
                  currFormat(getGrandTotal.totalDiscount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right font-weight-bold">
                <strong getGrandTotal.totalBalance>{{
                  currFormat(getGrandTotal.totalBalance)
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-none swc-report">
        <table class="swc-report swc-report-table" border="1">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $tc("outlet") }}</th>
              <th>{{ $tc("username") }}</th>
              <th>{{ $tc("item") }}</th>
              <th>{{ $tc("payment") }} {{ $tc("type") }}</th>
              <th>{{ $tc("offer") }}</th>
              <th>{{ $tc("quantity") }}</th>
              <th>{{ $tc("revenue") }}</th>
              <th>{{ $tc("revenue") }}</th>
              <th>{{ $tc("discount") }}</th>
              <th>{{ $tc("balance") }}</th>
            </tr>
          </thead>
          <tbody class="sph-report">
            <tr
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
              :key="ConcessionIndex"
            >
              <th rowspan="4" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top; text-align: left">
                    <th>Box Office</th>
                  </tr>
                </table>
              </th>
              <td rowspan="4" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top">
                    <td>Akash</td>
                  </tr>
                </table>
              </td>
              <td>
                <table>
                  <tr
                    v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                    :key="FnbItemIndex"
                  >
                    <td rowspan="2" class="p-0">
                      <table class="h-100 w-100">
                        <tr style="vertical-align: top">
                          <td>Pepsi</td>
                        </tr>
                      </table>
                    </td>
                    <td>
                      <table class="w-100">
                        <tr
                          v-for="(
                            PaymentItem, PaymentIndex
                          ) in FnbItem.paymentTypes"
                          :key="PaymentIndex"
                        >
                          <td>{{ PaymentItem.fst_payment_mode }}</td>
                        </tr>
                        <!-- <tr>
                    <td>Credit Card</td>
                        </tr>-->
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>20%</td>
              <td>3</td>
              <td>23</td>
              <td>5%</td>
              <td>3000</td>
            </tr>
            <tr>
              <td rowspan="2" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top">
                    <td>Burger</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>Cash</td>
                  </tr>
                  <tr>
                    <td>Credit Card</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>20%</td>
              <td>3</td>
              <td>23</td>
              <td>5%</td>
              <td>3000</td>
            </tr>
            <tr>
              <th rowspan="4" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top; text-align: left">
                    <th>Box Office</th>
                  </tr>
                </table>
              </th>
              <td rowspan="4" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top">
                    <td>Yogesh</td>
                  </tr>
                </table>
              </td>
              <td rowspan="2" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top">
                    <td>Pepsi</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>Cash</td>
                  </tr>
                  <tr>
                    <td>Credit Card</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>20%</td>
              <td>3</td>
              <td>23</td>
              <td>5%</td>
              <td>3000</td>
            </tr>
            <tr>
              <td rowspan="2" class="p-0">
                <table class="h-100 w-100">
                  <tr style="vertical-align: top">
                    <td>Burger</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>Cash</td>
                  </tr>
                  <tr>
                    <td>Credit Card</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>20%</td>
              <td>3</td>
              <td>23</td>
              <td>5%</td>
              <td>3000</td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="text-left" colspan="8">Grand Total :</td>
              <td>12000</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report mt-4">
        <div class="text-right align-self-end">
          <a
            v-if="getConcessionFnbItemExcel"
            :href="getConcessionFnbItemExcel"
            target="_blank"
            title="Download as Excel"
            class="ml-auto"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <a
            v-if="getConcessionFnbItemPdf"
            :href="getConcessionFnbItemPdf"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
        </div>
        <table border="1" class="swc-report swc-report-table">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $tc("item") }}</th>
              <th>Category</th>
              <th>{{ $tc("quantity") }}</th>
              <th>{{ $tc("gross") }} {{ $tc("revenue") }}</th>
              <th>{{ $tc("Food") }} {{ $tc("Cost") }}</th>
              <th>{{ $tc("Food") }} {{ $tc("Cost %") }}</th>
              <th>{{ $tc("net") }} {{ $tc("revenue") }}</th>
              <th>{{ $tc("discount") }}</th>
              <th>{{ $tc("balance") }}</th>
            </tr>
          </thead>
          <tbody v-if="getFnbItemList.length == 0">
            <tr rowspan="9">
              <td colspan="6">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="getFnbItemList && getFnbItemList.length > 0"
            class="sph-report"
          >
            <tr
              v-for="(fnbItem, fnbItemIndex) in getFnbItemList"
              :key="fnbItemIndex"
            >
              <td>{{ fnbItem.fst_item_name }}</td>
              <td>{{ fnbItem.fc_category }}</td>
              <td>{{ fnbItem.total_quantity }}</td>
              <td>{{ currFormat(fnbItem.total_amount) }}</td>
              <td>{{ currFormat(fnbItem.food_cost) }}</td>
              <td>
                {{
                  currFormat((fnbItem.food_cost / fnbItem.total_amount) * 100)
                }}%
              </td>
              <td>{{ currFormat(fnbItem.net_amount) }}</td>
              <td>{{ currFormat(fnbItem["ft_offer_price"]) }}</td>
              <td>{{ currFormat(fnbItem["balance_amount"]) }}</td>
            </tr>
          </tbody>
          <tbody v-if="getFnbItemList.length > 0 && false">
            <tr>
              <td class="bg-lightgrey">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>

              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <!-- <td class="bg-lightgrey">
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td> -->
              <td class="bg-lightgrey">
                <strong>{{ getGrandTotal.totalQuantity }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong v-if="getGrandTotal.totalRevenue">{{
                  currFormat(getGrandTotal.totalRevenue)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong v-if="getGrandTotal.totalNetAmount">{{
                  currFormat(getGrandTotal.totalNetAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong getGrandTotal.totalDiscount>{{
                  currFormat(getGrandTotal.totalDiscount)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong getGrandTotal.totalBalance>{{
                  currFormat(getGrandTotal.totalBalance)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      // getGrandTotal: [],
      searchCinema: "",
    };
  },
  computed: {
    getGrandTotal() {
      console.log(this.$store.getters.grandTotalForConcessionsReport);
      return this.$store.getters.grandTotalForConcessionsReport;
    },
    ...mapGetters([
      "getPosUsersList",
      "getCinemasList",
      "getConcessionReportSelectedPosUser",
      "getConcessionDailyReportsSelectedCinema",
      "getConcessionDailyReportsSelectedMovie",
      "getDistributorsMasterMovieList",
      "getConcessionDailyReportFromDate",
      "getConcessionDailyReportToDate",
      //"getRecipeReports",
      "getConcessionDailyReportData",
      // EXCEL
      "getConcessionDailyExcelFileName",
      "getConcessionFnbItemExcel",
      // PDF
      "getConcessionFnbItemPdf",
      "getConcessionDailyPdfFileName",
      "getFnbItemList",
    ]),
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.fetchCinemasList({ cinemaId });

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onConcessionDailyReportDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj,
      });
    }
    this.fetchDistributorsActiveMasterMovie();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onConcessionDailyReportDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj,
        });
      }
    },
  },
  methods: {
    subtractRefund(type, user_id) {
      let value = 0;
      this.getConcessionDailyReportData.forEach((ConcessionItem) => {
        if (user_id == ConcessionItem.user_id) {
          ConcessionItem.FnbItems.map((FnbItem) => {
            if (
              FnbItem.hasOwnProperty("DataRefund") &&
              FnbItem.DataRefund.length > 0
            ) {
              FnbItem.DataRefund.map((refundData) => {
                value += parseFloat(refundData[type]);
              });
            }
          });
        }
      });
      return value;
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    setLabel(event) {
      if (event.first_name && event.first_name.length > 0) {
        return `${event.first_name ? event.first_name : ""} ${
          event.middle_name ? event.middle_name : ""
        } ${event.last_name ? event.last_name : ""}`;
      } else {
        return "All";
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                // this.onRecipeReportDropDownHandler({  name:'isCinema',selectedItem: {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // } })
                this.onConcessionDailyReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  },
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "fetchPosUsersList",
      "onConcessionDailyReportDropDownHandler",
      "fetchDistributorsActiveMasterMovie",
      "onConcessionDailyReportDateHandler",
      "onFetchDailyConcessionReport",
    ]),
  },
};
</script>

<style>
.fixed-layout-table {
  width: 100%;
  table-layout: fixed;
  white-space: normal !important;
}

.swc-report,
.swc-report-table {
  white-space: normal !important;
}

.dailysales_report > tbody > tr > td {
  border: 1px dotted black;
}

.dailysales_report > tbody {
  border-bottom: 2px solid black;
}

.dailysales_report {
  zoom: 0.9;
  white-space: normal !important;
}

.table-elements-border > thead > tr > th:not(:last-child),
.table-elements-border > tbody > tr > td:not(:last-child) {
  border-right: 1px solid black;
}
.word_break {
  word-break: break-all;
}
/* .sph-report th,
td {
  height: 30px;
} */
/* table tr {
  white-space: normal !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/concessionDailyReport.vue